import { handleActions } from 'redux-actions';
import {
} from 'lodash';

import {
  INITIALIZE_FAILURE, INITIALIZE_REQUEST, INITIALIZE_SUCCESS, SET_PERIOD, SET_CANCEL_TOKEN,
  FETCH_RECORDS_REQUEST, FETCH_RECORDS_FAILURE, FETCH_RECORDS_SUCCESS,
} from './constants';

const initialState = {
  inOut: {
    employees: [],
    clockTypes: [],
    clockTypesById: {},
    datesBetween: [],
    loading: false,
    error: '',
    hasError: false,
    start: {},
    end: {},
    initialized: false,
    initializing: false,
    initializeFailed: false,
    periodFrom: '1',
    cancelToken: null,
  },
};

export default handleActions({
  [FETCH_RECORDS_REQUEST]: state => ({
    ...state,
    fetchingEntries: true,
    employees: [],
    error: '',
    hasError: false,
    loading: true,
  }),
  [FETCH_RECORDS_SUCCESS]: (state, {
    employees,
    clockTypes,
  }) => ({
    ...state,
    clockTypes,
    employees,
    loading: false,
  }),
  [FETCH_RECORDS_FAILURE]: (state, action) => ({
    ...state,
    loading: false,
    error: action.error,
    hasError: true,
  }),
  [INITIALIZE_REQUEST]: state => ({
    ...state,
    initialized: false,
    initializing: true,
    error: '',
    hasError: false,
    initializeFailed: false,
    loading: true,
  }),
  [INITIALIZE_SUCCESS]: (state, {
    periodFrom, orgCompanyUnits, defaultCompanyUnitID, clockTypesById, inOutFilters,
  }) => ({
    ...state,
    initialized: true,
    initializing: false,
    periodFrom,
    orgCompanyUnits,
    clockTypesById,
    defaultCompanyUnitID,
    inOutFilters,
    initializeFailed: false,
    loading: false,
  }),
  [INITIALIZE_FAILURE]: (state, { error }) => ({
    ...state,
    error,
    hasError: true,
    initialized: false,
    initializing: false,
    initializeFailed: true,
    loading: false,
  }),
  [SET_PERIOD]: (state, {
    start, end, datesBetween,
  }) => ({
    ...state,
    start,
    end,
    datesBetween,
  }),
  [SET_CANCEL_TOKEN]: (state, action) => ({
    ...state,
    cancelToken: action.cancelToken,
  }),
}, initialState.inOut);



// WEBPACK FOOTER //
// ./src/sites/inOut/reducer.js